import { observer } from 'mobx-react';
import { RootState } from '../../state/RootState';
import { GrantSPPermissions } from './GrantSPPermissions';
import { Label, Spinner, SpinnerSize } from '@fluentui/react';
import React from 'react';
import EntityTypes from './entity-types/EntityTypes';
import Administrators from './administrators/Administrators';
import LogStreaming from './logging/LogStreaming';
import PermissionsPage from './permissions/PermissionsPage';
import SearchAdminPage from './search/SearchAdminPage';
import EmailFilingAdminPage from './emailfiling/EmailFilingAdminPage';
import { Pages } from '../../Pages';

interface IPageRouterProps {
	rootState: RootState;
}

class PageRouter extends React.Component<IPageRouterProps, {}> {
	componentDidMount(): void {
		this.props.rootState.initialize();
	}

	render() {
		if (
			this.props.rootState.isUserInfoLoading ||
			!this.props.rootState.isUserInfoLoaded
		)
			return <Spinner size={SpinnerSize.large} />;

		return (
			<div style={{ paddingTop: 10, paddingLeft: 10 }}>
				{this.getPage(this.props.rootState)}
			</div>
		);
	}

	private getPage(rootState: RootState) {
		let pageSlug = rootState.page || '';

		if (pageSlug.startsWith('code=') || pageSlug.startsWith('id_token=')) {
			//We've just completed granting permissions, so refresh the page
			window.location.href = 'https://' + window.location.host;
			return <Spinner />;
		}

		if (rootState.spAuth.serverConnectionLost)
			return <Label>Server connection lost. Please refresh and try again.</Label>;

		if (!rootState.isUserInfoLoaded) return <Spinner></Spinner>;

		if (rootState.spAuth.spAuthRequired)
			return <GrantSPPermissions RootState={rootState}></GrantSPPermissions>;

		if (!rootState.userConfig?.isAdmin)
			return <Label>You don't have admin access to this application. Please contact your administrator.</Label>;

		if (pageSlug.startsWith(Pages.permissions) && rootState.settingsState) {
			return <PermissionsPage state={rootState.settingsState} />;
		}

		if (pageSlug.startsWith(Pages.emailFiling) && rootState.settingsState) {
			return <EmailFilingAdminPage state={rootState.settingsState} />;
		}

		if (pageSlug.startsWith(Pages.admins) && rootState.settingsState) {
			return <Administrators state={rootState.settingsState} />;
		}

		if (pageSlug.startsWith(Pages.types) && rootState.userConfig && rootState.entityTypes) {
			return <EntityTypes state={rootState.entityTypes} />;
		}

		if (pageSlug.startsWith(Pages.logs) && rootState.userConfig && rootState.logs) {
			return <LogStreaming state={rootState.logs} />;
		}

		if (pageSlug.startsWith(Pages.search) && rootState.settingsState && rootState.searchScopes && rootState.managedProps) {
			return <SearchAdminPage settingsState={rootState.settingsState} searchScopes={rootState.searchScopes} managedProps={rootState.managedProps} />;
		}

		return <div>page not found: {rootState.page}</div>;
	}
}

export default observer(PageRouter);
